import PropTypes from 'prop-types';
import style from './char-counter.module.scss';

// Renders a live "X/Y" character count with threshold coloring.
// Use next to a field label so the input itself remains free for
// an icon (matching auth Input pattern).
function CharCounter({ value, max }) {
  const current = typeof value === 'string' ? value.length : 0;
  const ratio = max ? current / max : 0;
  let tone = '';
  if (ratio >= 1) tone = style.full;
  else if (ratio >= 0.85) tone = style.warn;

  return (
    <span className={`${style.counter} ${tone}`} aria-live="polite">
      {`${current}/${max}`}
    </span>
  );
}

CharCounter.propTypes = {
  value: PropTypes.string,
  max: PropTypes.number.isRequired,
};

export default CharCounter;
